export const PENDING_STATE_SECONDS = 300;

export const isCheckPending = (isUp: boolean, createdAgoSec: number): boolean => {
  return !isUp && createdAgoSec < PENDING_STATE_SECONDS;
};
